// extracted by css-extract-rspack-plugin
export default {"Box":"BlameAgeLegend-module__Box__B4W67","Text":"BlameAgeLegend-module__Text__I2ym9","Box_1":"BlameAgeLegend-module__Box_1__NJDCG","Text_1":"BlameAgeLegend-module__Text_1__OmU21"};